import { call, put, takeLatest } from 'redux-saga/effects'
import { createAccountSuccess, signInSuccess, mfaSuccess, signInMFA, forgetPasswordSuccess} from './action';
import { Api } from './api'
import {
  CHANGE_PASSWORD,
  CREATE_ACCOUNT,
  FORGET_PASSWORD,
  MFA_AUTHENTICATION,
  REQUEST_FAILED,
  RESEND_CODE_MFA,
  RESEND_MFA_CODE_SUCCESS,
  SIGN_IN
} from './types'

function* createAccount(action) {
  try {
    const data = yield call(Api.createAccount, action.payload);
    yield put(createAccountSuccess(data));
  } catch (error) {
    yield put(createAccountSuccess());
  }
}

function* signIn(action) {
  try {
    const response = yield call(Api.signIn, action.payload);

    if (response.error) {
      yield put({ type: REQUEST_FAILED, payload: { error: response.message } });
      return;
    }

    if (response?.data?.required_mfa) {
        action.navigate('/verifyEmail')
        yield put(signInMFA(response.data));
    }
    else if (!response?.data?.required_mfa) {
      const email = response?.data?.username;
      const first_name = response?.data?.first_name
      const last_name = response?.data?.last_name
      setSession(email, first_name, last_name);

      action.navigate('/dashboard')
      yield put(signInSuccess(response.data));
    }

  } catch (error) {
    console.log('error', error);
  }
}

function* mfaAuthentication(action) {
  try {
    const response = yield call(Api.mfaAuthentication, action.payload);

    if (response?.status === 200) {
      setSession(response.data.username, response.data.first_name, response.data.last_name)
      action.navigate('/dashboard');
      yield put(mfaSuccess(response.data));
    } else {
      yield put({
        type: REQUEST_FAILED,
        payload: { error: response?.data?.message || response?.message},
      });
    }

  } catch (error) {
    yield put({
      type: REQUEST_FAILED,
      payload: {
        error: error.message || 'Unexpected error',
      },
    });
  }
}

function setSession(email, first_name, last_name) {
  localStorage.setItem('email', email);
  localStorage.setItem('first_name', first_name)
  localStorage.setItem('last_name', last_name)
  localStorage.setItem('isLoggedIn', true)
}

function* forgetPassword(action) {
  try {
    const response = yield call(Api.forgetPassword, action.payload);

    if (response?.status === 200) {
      yield put(forgetPasswordSuccess(response.data));
      action.navigate('/resetPassword');
    } else if (response?.error) {
      yield put({
        type: REQUEST_FAILED,
        payload: { error: response.message || 'Something went wrong' },
      });
    } else {
      yield put({
        type: REQUEST_FAILED,
        payload: { error: 'Unexpected error occurred' },
      });
    }

  } catch (error) {
    yield put({
      type: REQUEST_FAILED,
      payload: { error: error.message || 'Unexpected error occurred' },
    });
  }
}


function* changePassword(action) {
  try {
    const response = yield call(Api.changePassword, action.payload);

    if (response?.status === 200) {
      action.navigate('/login');
    } else {
      yield put({
        type: REQUEST_FAILED,
        payload: { error: response?.data?.message },
      });
    }

  } catch (error) {
    yield put({
      type: REQUEST_FAILED,
      payload: {
        error: error.message || 'Unexpected error',
      },
    });
  }
}

function* resendMfaCode() {
  try {
    const response = yield call(Api.resendMfaCode);

    if (response.status === 200) {
      yield put({ type: RESEND_MFA_CODE_SUCCESS, payload: response.data });
    } else {
      yield put({
        type: REQUEST_FAILED,
        payload: { error: response.data?.error || 'Unexpected error' },
      });
    }
  } catch (error) {
    yield put({
      type: REQUEST_FAILED,
      payload: { error: error.message || 'Unexpected error' },
    });
  }
}


function* userAuthSaga() {
  yield takeLatest(CREATE_ACCOUNT, createAccount);
  yield takeLatest(SIGN_IN, signIn);
  yield takeLatest(MFA_AUTHENTICATION, mfaAuthentication);
  yield takeLatest(FORGET_PASSWORD, forgetPassword);
  yield takeLatest(CHANGE_PASSWORD, changePassword);
  yield takeLatest(RESEND_CODE_MFA, resendMfaCode);
}

export default userAuthSaga;
